// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"aac64134","84":"19d14556","238":"d267301a","591":"24883498","597":"731d51b5","978":"062cd804"}[chunkId] + ".chunk.js";
};